export function shortHash(hash: string): string {
  if (hash.length < 12) {
    throw new Error("Hash is too short to extract 6 characters from both ends.")
  }

  return hash.slice(0, 6) + "..." + hash.slice(-6)
}
